import {
  mysqlTable,
  int,
  bigint,
  varchar,
  longtext,
  boolean,
  timestamp,
} from "drizzle-orm/mysql-core";
import { companies } from "./tenancy";
import { users } from "./identity";

/**
 * Letter module (HR letters: offer/experience/etc.). Ported line-by-line from
 * Modules/Letter/Database/Migrations/* (2023_11_15_*). These tables use `company_id` NOT NULL
 * and `softDeletes` (deleted_at) — preserved. letter_settings is a GLOBAL license/settings
 * table (no company_id).
 */

export const letterSettings = mysqlTable("letter_settings", {
  id: bigint("id", { mode: "number", unsigned: true }).autoincrement().primaryKey(),
  purchaseCode: varchar("purchase_code", { length: 255 }),
  supportedUntil: timestamp("supported_until"),
  purchasedOn: timestamp("purchased_on"),
  notifyUpdate: boolean("notify_update").default(true).notNull(),
  licenseType: varchar("license_type", { length: 20 }),
  createdAt: timestamp("created_at"),
  updatedAt: timestamp("updated_at"),
});

export const letterTemplates = mysqlTable("letter_templates", {
  id: int("id", { unsigned: true }).autoincrement().primaryKey(),
  companyId: int("company_id", { unsigned: true })
    .notNull()
    .references(() => companies.id, { onDelete: "cascade", onUpdate: "cascade" }),
  title: varchar("title", { length: 255 }).notNull(),
  description: longtext("description").notNull(),
  createdAt: timestamp("created_at"),
  updatedAt: timestamp("updated_at"),
  deletedAt: timestamp("deleted_at"),
});

export const letters = mysqlTable("letters", {
  id: int("id", { unsigned: true }).autoincrement().primaryKey(),
  companyId: int("company_id", { unsigned: true })
    .notNull()
    .references(() => companies.id, { onDelete: "cascade", onUpdate: "cascade" }),
  userId: int("user_id", { unsigned: true }).references(() => users.id, {
    onDelete: "cascade",
    onUpdate: "cascade",
  }),
  templateId: int("template_id", { unsigned: true })
    .notNull()
    .references(() => letterTemplates.id, { onDelete: "cascade", onUpdate: "cascade" }),
  creatorId: int("creator_id", { unsigned: true }).references(() => users.id, {
    onDelete: "set null",
    onUpdate: "cascade",
  }),
  name: varchar("name", { length: 255 }),
  top: varchar("top", { length: 255 }).notNull(),
  right: varchar("right", { length: 255 }).notNull(),
  left: varchar("left", { length: 255 }).notNull(),
  bottom: varchar("bottom", { length: 255 }).notNull(),
  description: longtext("description"),
  createdAt: timestamp("created_at"),
  updatedAt: timestamp("updated_at"),
  deletedAt: timestamp("deleted_at"),
});
